function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105px",
    height: "205px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152 401",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "e1_line",
    x1: 5,
    y1: 5,
    x2: 70,
    y2: 100,
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 10,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "e1_line",
    x1: 70,
    y1: 100,
    x2: 5,
    y2: 200,
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 10,
      strokeLinecap: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d42f1ffca347d005496ae8f78b13686c.svg";
export { ForwardRef as ReactComponent };